import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class ContractService
    extends BaseService {

    static async getLatest() {
        return BaseService.callAPI('contract/get-latest');
    }

    static async list() {
        return BaseService.callAPI('contract/list');
    }

    static async get(param) {
        return BaseService.callAPI('contract/get', param);
    }

    static async listVersions(param) {
        return BaseService.callAPI('contract/list-versions', param);
    }

    static async listExcel() {
        return BaseService.callAPI('contract/list-excel', {
            isDownload: true,
            fileName: 'Contracts.xlsx'
        });
    }

    static async sendLinks(ids) {
        return BaseService.callAPI('contract/send-links', {
            ids
        });
    }

    static async sendPDF(contractID) {
        return BaseService.callAPI('contract/send-pdf/' + contractID);
    }

    static async regeneratePDF(contractID) {
        return BaseService.callAPI('contract/regenerate-pdf/' + contractID);
    }

    static async createNewVersion(contractID) {
        return BaseService.callAPI('contract/create-new-version/' + contractID);
    }

    static async sign(signature, newPassword) {
        return BaseService.callAPI('contract/sign', {
            signature,
            newPassword
        });
    }

    static async updateAddress(address) {
        return BaseService.callAPI('contract/update-address', { address });
    }

    static async save(contract) {
        return BaseService.callAPI('contract/save', contract);
    }
}
